/**
 * JWT Cookie authentication (see backend docs JWT-TO-COOKIE-AUTHENTICATION.md).
 * When true: use HttpOnly cookie for JWT (withCredentials), do not send Authorization header.
 * When false: use token from localStorage and send Authorization: Bearer <token>.
 * Set VITE_USE_JWT_COOKIE=true in .env to try cookie-based auth.
 */
export const USE_JWT_COOKIE = import.meta.env.VITE_USE_JWT_COOKIE === 'true'

/** Storage key for token when using cookie (sessionStorage so validators can still decode if backend sends token in body) */
export const COOKIE_MODE_TOKEN_KEY = 'token_session'
